// extracted by mini-css-extract-plugin
export default {"root":"Counter_root__fj0sp","primary":"Counter_primary__BqG4v","neutral":"Counter_neutral__zoSuj","dot":"Counter_dot__IERIf"};